import axios from 'axios';
import {loadUserDetails} from './userDetails';
import isLoggedIn from 'lib/isLoggedIn';
import {getIn} from 'lib/immutableObject';
import {push} from 'react-router-redux';

const UPDATE = 'pulp/login/UPDATE';
const CLEAR = 'pulp/login/CLEAR';

export const initialState = {
  loggedIn: isLoggedIn(),
  username: null,
  customers: [],
  errorMessage: null,
  timedout: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE:
      return {
        ...state,
        ...action.payload,
      };
    case CLEAR:
      return {
        ...initialState,
        username: state.username,
        loggedIn: false,
        timedout: isLoggedIn() ? Date.now() : null,
      };
    default:
      return state;
  }
}

export function updateLogin(payload) {
  return {
    type: UPDATE,
    payload,
  };
}

export function clearLogin() {
  return {
    type: CLEAR
  };
}

export function loadLoginCustomers({username, password}) {
  return (dispatch) => {
    return axios.post('/api/user-login-customers', {username, password})
      .then(({data: {customers}}) => {
        if (customers.length === 1) {
          dispatch(postLogin({username, password, customerId: customers[0].id}));
        } else {
          dispatch(updateLogin({customers}));
        }
        dispatch(updateLogin({username}));
      })
      .catch(({response: {data: {message}}}) => {
        dispatch(updateLogin({errorMessage: message || 'Invalid Credentials'}));
      });
  };
}

export function postLogin({username, password, customerId}) {
  return async (dispatch) => {
    try {
      await axios.post('/api/user-login', {username, password, customerId});
      dispatch(loadUserDetails());
      dispatch(updateLogin({loggedIn: true, username, errorMessage: null}));
    } catch ({response: {data: {message}}}) {
      dispatch(updateLogin({errorMessage: message || 'Invalid Credentials'}));
    }
  };
}

function decodeQueryString(queryString) {
  return queryString.substring(1).split('&')
    .reduce((acc, param) => {
      const i = param.indexOf('=');
      acc[decodeURIComponent(param.substring(0, i))] = decodeURIComponent(param.substring(i + 1));
      return acc;
    }, {});
}

export function getApiLogin() {
  return async (dispatch) => {
    const queryString = window.location.search;
    const params = decodeQueryString(queryString);
    let redirectUrl = params.redirectUrl;
    if (redirectUrl && redirectUrl.indexOf('#') !== -1) {
      redirectUrl = redirectUrl.substr(redirectUrl.indexOf('#') + 1);
    }

    if (params.timestamp && params.hash && params.token && params.accountId) {
      try {
        await axios.get('/api/login' + queryString, {headers: {accept: 'application/json'}});
        dispatch(loadUserDetails());
        dispatch(updateLogin({loggedIn: true, errorMessage: null}));
      } catch (e) {
        try {
          dispatch(updateLogin({errorMessage: getIn(e, ['response', 'data', 'message']) || 'Invalid Credentials'}));

        } catch (err) {}
      }

      window.history.pushState({}, '', '/#/');
      dispatch(push(redirectUrl || '/properties/search'));
    }
  };
}